module.exports = __webpack_public_path__ + "4e09c00f3c09f604598cfad9d642d264.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-22.png
 ** module id = 1013
 ** module chunks = 0
 **/